import { z } from "zod";
import { CefrLevelSchema, ChunkSchema, FrequencySchema, SpeakingUsageSchema, TopicSchema } from "./vocab.js";
export const VocabGenerateRequestSchema = z.object({
    word: z.string().min(1).max(80),
    vietnamese: z.string().max(200).optional(),
    example_domain: z.string().min(2).max(80).optional(),
});
export const VocabGeneratedSchema = z.object({
    word: z.string().min(1),
    type: z.string().min(1),
    ipa: z.string().min(1),
    meaning_simple_en: z.string().min(1),
    vietnamese: z.string().optional(),
    core_idea: z.string().min(1),
    examples: z.array(z.string().min(1)).min(2).max(3),
    chunks: z.array(ChunkSchema).min(3).max(5),
    synonyms: z.array(z.string().min(1)).max(12).optional(),
    antonyms: z.array(z.string().min(1)).max(12).optional(),
    speaking_usage: SpeakingUsageSchema,
    common_mistakes: z.array(z.string()).max(4),
    memory_hook: z.string().min(1),
    vn_phrase_translation: z.string().min(1),
    topics: z.array(TopicSchema).min(1).max(3),
    frequency: FrequencySchema,
    cefr_level: CefrLevelSchema,
});
export const VocabGenerateResponseSchema = z.object({
    is_valid_word: z.boolean(),
    suggestion: z.string().optional(),
    generated: VocabGeneratedSchema.optional(),
    cached: z.boolean(),
    existing_entry_id: z.string().uuid().optional(),
});
//# sourceMappingURL=ai.js.map